/* Bean Shipper · Find My Beans, Fresh v3 engine (assets/bs-fmbx.js, 19 Oct 2026).
 * Mounted by sections/page__bs-fmb-x.liquid on both quiz pages:
 *   /pages/quiz           mode "reveal": intro > Q1..Q4 > brewing > RESULT (coffee, optional email)
 *   /pages/find-my-beans  mode "gated":  intro > Q1..Q4 > brewing > PROFILE (personality, mystery bag,
 *                         email gate) > native POST to /contact (hCaptcha) > RESULT
 * Replaces bs-fmb.js (reveal) and bs-fmb2.js (gated). Both stay on the theme for rollback.
 *
 * CONTRACTS KEPT. Read the files that depend on them before changing any of this:
 * - Quiz data and matching: QUESTIONS (ids, options, scores), PROFILES (keys, names, targets,
 *   runner-ups), scoreQuiz, productScore, bestProduct (bundles, sold-out and drip boxes never match)
 *   and pickVariant are the 23 Sep 2026 logic, so personalities and the fmb-<key> / rec-<handle>
 *   customer tags stay comparable with every lead since then. Night Owl's copy lost its caffeine
 *   claims (v6 bans them); its key, name and target are unchanged.
 * - sections/bs-lead-pixel.liquid reads #bs-fmb-products while the page parses (this engine never
 *   rewrites #bs-fmb.innerHTML, so it stays), takes the last dataLayer
 *   {event:'QuizComplete', quiz:{personality:<key>, match:<product title>}} or falls back to
 *   .result__name / .prodcard__name, fires Lead on ?customer_posted=true, and appends its tags to
 *   form[data-act="signup-form"] input[name="contact[tags]"] in a capture-phase submit listener.
 * - Sign-up is a real Shopify customer form bound with Shopify.captcha.protect(form) and submitted
 *   natively. Never post it by script: an unbound form gets no hCaptcha token and Shopify answers
 *   400 "Missing CAPTCHA token" (the 23 Sep 2026 bug). Answers wait in sessionStorage
 *   'bsfmb:pending' {mode, answers, email, submitted, path, ts}; ?customer_posted=true is the ONLY
 *   confirmed sign-up; 'bsfmb:revealed' keeps a revealed result for 45 minutes.
 * - Add to bag uses the theme cart: form[data-bs-add] + button[data-bs-pdp-add], so the ajax cart
 *   adds the line, shows "Adding…", surfaces errors and opens the drawer (purchase-flow checklist).
 * - Analytics: the gated page keeps fbq trackCustom QuizComplete / QuizEmailCapture / QuizGateSkipped
 *   plus the dataLayer push. The reveal page pushes QuizComplete to the dataLayer only (the pixel
 *   forwards it once), which is what the pixel's DOM fallback used to send.
 * Motion is transform-only, and content never fades. prefers-reduced-motion: no particles, no orbit,
 * no slides, a short brewing beat.
 */
(function () {
  'use strict';
  var root = document.getElementById('bs-fmb');
  if (!root || !root.hasAttribute('data-fmbx') || root.getAttribute('data-fmbx-on')) return;
  root.setAttribute('data-fmbx-on', '1');

  /* ---------- helpers ---------- */
  function qs(el, s) { return el ? el.querySelector(s) : null; }
  function qsa(el, s) { return el ? Array.prototype.slice.call(el.querySelectorAll(s)) : []; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function mm(q) { try { return window.matchMedia(q).matches; } catch (e) { return false; } }
  var reduce = mm('(prefers-reduced-motion: reduce)');
  var fine = mm('(hover: hover) and (pointer: fine)');
  function money(c) {
    c = Math.round(c || 0);
    var i = Math.floor(c / 100), s = c % 100;
    return 'RM' + String(i).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (s ? '.' + (s < 10 ? '0' : '') + s : '');
  }
  function grams(label) {
    var v = String(label || '').split(' - ')[0].toLowerCase().replace(/\s+/g, '').replace('×', 'x');
    var n = 1, per = v;
    if (v.indexOf('x') > 0) { n = parseFloat(v.split('x')[0]); per = v.split('x')[1]; }
    var m = /^(\d+(?:\.\d+)?)(kg|g)$/.exec(per || '');
    if (!m || !(n > 0)) return 0;
    return (m[2] === 'kg' ? parseFloat(m[1]) * 1000 : parseFloat(m[1])) * n;
  }
  function bags(label) {
    var v = String(label || '').split(' - ')[0].toLowerCase().replace(/\s+/g, '').replace('×', 'x');
    return v.indexOf('x') > 0 ? (parseFloat(v.split('x')[0]) || 1) : 1;
  }
  function shortLabel(label) { return String(label || '').split(' - ')[0].replace(/\s*x\s*/i, ' × '); }
  function hex(h) { h = String(h || '').replace('#', ''); if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]; return [parseInt(h.substr(0, 2), 16) || 0, parseInt(h.substr(2, 2), 16) || 0, parseInt(h.substr(4, 2), 16) || 0]; }
  function mix(a, b, t) { var x = hex(a), y = hex(b); return 'rgb(' + [0, 1, 2].map(function (i) { return Math.round(x[i] + (y[i] - x[i]) * t); }).join(',') + ')'; }
  function ramp(stops, t) {
    t = clamp(t, 0, 1);
    for (var i = 1; i < stops.length; i++) {
      if (t <= stops[i][0]) { var a = stops[i - 1], b = stops[i]; return mix(a[1], b[1], (t - a[0]) / ((b[0] - a[0]) || 1)); }
    }
    return mix(stops[stops.length - 1][1], stops[stops.length - 1][1], 0);
  }
  var uid = 0;
  function nid(p) { uid += 1; return p + uid; }

  /* ---------- data from the section ---------- */
  var POOL = [], CFG = {};
  try { POOL = JSON.parse((document.getElementById('bs-fmb-products') || {}).textContent || '[]'); } catch (e) { POOL = []; }
  try { CFG = JSON.parse((document.getElementById('bs-fmb-config') || {}).textContent || '{}'); } catch (e) { CFG = {}; }
  var MODE = CFG.mode === 'gated' ? 'gated' : 'reveal';
  var BASE = (window.Shopify && Shopify.routes && Shopify.routes.root) || CFG.root || '/';
  if (BASE.slice(-1) !== '/') BASE += '/';
  var SHOP = String(CFG.shop || 'Bean Shipper').toLowerCase();
  var SHIP = CFG.ship || '';
  var BROWSE = CFG.browseUrl || (BASE + 'collections/all-beans');
  var NOTE_TITLE = CFG.note_title || 'Get brewing tips and new roasts by email.';
  var GATE_TITLE = CFG.gate_title || 'Your match is <em>poured.</em>';
  var GATE_SUB = CFG.gate_sub || 'Your email unlocks the coffee, plus brewing tips and new roasts from us.';
  var GATE_BTN = CFG.gate_btn || 'Show me my coffee';
  var GATE_PERK = CFG.gate_perk || '';
  var GATE_CODE = CFG.gate_code || '';
  var ALLOW_SKIP = CFG.allow_skip === true;
  var PINS = CFG.pins || {};
  var CAPTURE_TAGS = CFG.capture_tags || (MODE === 'gated' ? 'newsletter, find-my-beans, find-my-beans-gated' : 'newsletter, find-my-beans');

  /* ---------- the quiz (23 Sep 2026 logic, unchanged) ---------- */
  var QUESTIONS = [
    { id: 'brew', cat: 'Ritual', q: 'How do you make your morning cup?', sub: "There's no wrong answer, only the one that feels like home.", layout: 'cards', tone: '#F2B36B', options: [
      { id: 'espresso', label: 'Espresso machine', desc: 'Short, intense, no compromise', icon: 'espresso', scores: { purist: 2, comfort: 1 } },
      { id: 'pourover', label: 'Pour-over', desc: 'Slow, deliberate, a little ceremony', icon: 'pourover', scores: { explorer: 2, romantic: 1 } },
      { id: 'dripbag', label: 'Drip bag', desc: 'Good coffee, anywhere I land', icon: 'dripbag', scores: { comfort: 2, nightowl: 1 } },
      { id: 'frenchpress', label: 'French press', desc: 'Full-bodied and unhurried', icon: 'frenchpress', scores: { purist: 1, comfort: 1, explorer: 1 } }
    ] },
    { id: 'flavor', cat: 'Palate', q: 'Which flavour makes you close your eyes?', sub: 'Trust your gut: the cup you would reach for twice.', layout: 'cards', tone: '#F29A7B', options: [
      { id: 'fruity', label: 'Bright & fruity', desc: 'Berries, citrus, a little sparkle', icon: 'fruit', scores: { explorer: 3, romantic: 1 } },
      { id: 'chocolatey', label: 'Rich & chocolatey', desc: 'Cocoa, caramel, deep and round', icon: 'cocoa', scores: { purist: 3, comfort: 1 } },
      { id: 'nutty', label: 'Smooth & nutty', desc: 'Almond, brown sugar, easy-going', icon: 'nut', scores: { comfort: 3, purist: 1 } },
      { id: 'floral', label: 'Delicate & floral', desc: 'Jasmine, tea-like, light on its feet', icon: 'floral', scores: { romantic: 3, explorer: 1 } }
    ] },
    { id: 'roast', cat: 'Roast', q: 'How dark do you like it?', sub: 'From sun-kissed to midnight. Slide to your shade.', layout: 'roast', tone: '#E9B98A', options: [
      { id: 'light', label: 'Light', desc: 'Tea-like, vivid, acidic', swatch: '#C9A06A', scores: { explorer: 2, romantic: 2 } },
      { id: 'medium', label: 'Medium', desc: 'Balanced, sweet, familiar', swatch: '#8A5333', scores: { comfort: 2, romantic: 1 } },
      { id: 'dark', label: 'Dark', desc: 'Bold, smoky, full force', swatch: '#3A2218', scores: { purist: 3, nightowl: 1 } }
    ] },
    { id: 'spirit', cat: 'Spirit', q: "At the counter, you're the kind who…", sub: 'Be honest. Both are a perfectly good way to live.', layout: 'cards', tone: '#EFA3B8', options: [
      { id: 'surprise', label: '“Surprise me”', desc: 'Always chasing the next discovery', icon: 'compass', scores: { explorer: 3, romantic: 1 } },
      { id: 'reliable', label: '“The usual”', desc: 'Found my order, never looked back', icon: 'anchor', scores: { comfort: 2, purist: 2 } }
    ] }
  ];
  var N = QUESTIONS.length;

  var PROFILES = {
    explorer: { name: 'The Explorer', tagline: 'You drink to discover.',
      blurb: 'You treat every cup like a postcard from somewhere new, and the brighter it is, the better. A fruity, floral coffee isn’t a novelty to you. It’s the point.',
      traits: ['Bright', 'Adventurous', 'Light roast'], runnerUp: 'romantic', pc: '#C4551F', tone: '#F6A26F', icon: 'compass',
      target: { roast: 'light-roast', flavors: ['fruity', 'floral'] } },
    purist: { name: 'The Purist', tagline: 'You take it seriously, and straight.',
      blurb: 'No frills, no fuss: a deep, chocolatey cup made the way it should be. You know what you like, and you’ve earned the right to be particular about it.',
      traits: ['Bold', 'Reliable', 'Dark roast'], runnerUp: 'comfort', pc: '#3A2218', tone: '#C9A27E', icon: 'bean',
      target: { roast: 'dark-roast', flavors: ['chocolate', 'caramel'] } },
    romantic: { name: 'The Romantic', tagline: 'You drink for the moment, not the rush.',
      blurb: 'Coffee is a slow ceremony for you, floral and tea-like, poured by hand while the kettle ticks. You’d rather savour one beautiful cup than gulp three good ones.',
      traits: ['Floral', 'Considered', 'Light–medium'], runnerUp: 'explorer', pc: '#B63A64', tone: '#F2A9C0', icon: 'heart',
      target: { roast: 'light-roast', flavors: ['floral', 'fruity'] } },
    comfort: { name: 'The Comfort Seeker', tagline: 'You drink for the warm, familiar middle.',
      blurb: 'Smooth and nutty, the cup that feels like a soft landing. You don’t need fireworks. You need a brew that’s good every morning without asking much of you.',
      traits: ['Smooth', 'Easy-going', 'Medium roast'], runnerUp: 'purist', pc: '#9A5F26', tone: '#EBC48C', icon: 'mug',
      target: { roast: 'medium-roast', flavors: ['nutty', 'caramel'] } },
    nightowl: { name: 'The Night Owl', tagline: 'You save the best cup for the evening.',
      blurb: 'Coffee, for you, belongs to the slow end of the day: a cocoa-rich cup with a book, a film or a long chat. You like it smooth and round, and you take your time with it.',
      traits: ['Mellow', 'Evening cup', 'Cocoa-rich'], runnerUp: 'comfort', pc: '#5B3557', tone: '#CDA9C7', icon: 'moon',
      target: { roast: 'medium-roast', flavors: ['chocolate'], decaf: true } }
  };
  var ORDER = ['explorer', 'purist', 'romantic', 'comfort', 'nightowl'];

  function scoreQuiz(ans) {
    var totals = { explorer: 0, purist: 0, romantic: 0, comfort: 0, nightowl: 0 };
    QUESTIONS.forEach(function (question) {
      var chosenId = ans[question.id];
      if (!chosenId) return;
      var opt = null;
      question.options.forEach(function (o) { if (o.id === chosenId) opt = o; });
      if (!opt || !opt.scores) return;
      Object.keys(opt.scores).forEach(function (k) { totals[k] = (totals[k] || 0) + opt.scores[k]; });
    });
    var best = ORDER[0];
    ORDER.forEach(function (k) { if (totals[k] > totals[best]) best = k; });
    return best;
  }
  function productScore(p, target) {
    var s = 0;
    if (p.match_roast === target.roast) s += 3;
    var fl = p.match_flavor || [];
    (target.flavors || []).forEach(function (f) { if (fl.indexOf(f) !== -1) s += 2; });
    if (target.decaf && /decaf/i.test((p.id || '') + ' ' + (p.name || ''))) s += 3;
    return s;
  }
  /* A drip box is a box of sachets, not a bag of beans (23 Sep 2026). Name AND handle, so a bean
     whose VARIANT is a drip grind is never caught. */
  function isDrip(p) { return /drip/i.test((p.name || '') + ' ' + (p.id || '')); }
  function bestProduct(profileId, excludeHandle) {
    if (!POOL.length) return null;
    var target = PROFILES[profileId].target;
    var best = null, bestScore = -1;
    for (var i = 0; i < POOL.length; i++) {
      var p = POOL[i];
      if (excludeHandle && p.id === excludeHandle) continue;
      if (p.bundle) continue;
      if (p.available === false) continue;
      if (isDrip(p)) continue;
      var sc = productScore(p, target);
      if (sc > bestScore) { bestScore = sc; best = p; }
    }
    if (!best) {
      for (var j = 0; j < POOL.length; j++) { if (POOL[j].id !== excludeHandle && !POOL[j].bundle && POOL[j].available !== false && !isDrip(POOL[j])) { best = POOL[j]; break; } }
    }
    return best || POOL[0];
  }
  /* 27 Oct 2026 (Kai): every result opens on Whole Bean, whatever the brew answer. An espresso answer used to
     preselect the Espresso grind (French press, drip bag likewise). Other grinds stay one tap away on the card. */
  var GRIND_BY_BREW = { espresso: 'whole bean', frenchpress: 'whole bean', dripbag: 'whole bean', pourover: 'whole bean' };
  function pickVariant(p) {
    var vs = (p && p.variants) || [];
    if (!vs.length) return p ? { id: p.variant_id, title: p.format } : null;
    var want = GRIND_BY_BREW[answers.brew] || 'whole bean';
    var i, t;
    for (i = 0; i < vs.length; i++) { t = String(vs[i].title || '').toLowerCase(); if (t.indexOf(want) !== -1 && vs[i].available !== false) return vs[i]; }
    for (i = 0; i < vs.length; i++) { t = String(vs[i].title || '').toLowerCase(); if (t.indexOf('whole bean') !== -1 && vs[i].available !== false) return vs[i]; }
    for (i = 0; i < vs.length; i++) { if (vs[i].available !== false) return vs[i]; }
    return vs[0];
  }
  function roastLabel(r) { return r === 'light-roast' ? 'Light roast' : r === 'dark-roast' ? 'Dark roast' : 'Medium roast'; }
  function roastName(p) { var m = String((p && p.roast_meta) || '').trim(); return m ? cap(m.toLowerCase()) + (/roast/i.test(m) ? '' : ' roast') : roastLabel(p && p.match_roast); }
  function roastPos(word) {
    var w = String(word || '').toLowerCase();
    if (/medium[\s-]*dark|dark[\s-]*medium/.test(w)) return 0.7;
    if (/medium[\s-]*light|light[\s-]*medium/.test(w)) return 0.3;
    if (/dark/.test(w)) return 0.9;
    if (/light/.test(w)) return 0.1;
    return 0.5;
  }
  function noteChips(p) {
    var notes = String((p && p.notes) || '').split(/[,·•]/).map(function (n) { return n.trim(); }).filter(Boolean);
    if (!notes.length) notes = ((p && p.match_flavor) || []).map(cap);
    return notes.slice(0, 3);
  }
  function isOwn(p) { return !!p && (!p.vendor || String(p.vendor).toLowerCase() === SHOP); }

  /* ---------- state ---------- */
  var step = 'intro', answers = {}, result = null, heroP = null, heroV = null, runnerP = null, runnerId = null;
  var noteSent = false, restoreError = '', restoredEmail = '', busy = false, fresh = false;

  /* ---------- analytics ---------- */
  function track(ev, data) {
    if (MODE === 'gated') { try { if (typeof window.fbq === 'function') window.fbq('trackCustom', ev, data || {}); } catch (e) {} }
    try { (window.dataLayer = window.dataLayer || []).push({ event: ev, quiz: data || {} }); } catch (e) {}
  }

  /* ---------- native sign-up (hCaptcha-safe), the 23 Sep 2026 logic ---------- */
  var PENDING_KEY = 'bsfmb:pending', REVEALED_KEY = 'bsfmb:revealed';
  function ssGet(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  function isFresh(o) { return !!(o && o.answers && o.path === location.pathname && (Date.now() - (o.ts || 0)) < 45 * 60 * 1000); }
  function savePending(mode, email, submitted) {
    ssSet(PENDING_KEY, { mode: mode, answers: answers, email: email, submitted: !!submitted, path: location.pathname, ts: Date.now() });
  }
  function contactAction() { return BASE + 'contact#bs-fmb'; }
  function signupFormHTML(btnLabel) {
    return '<form class="fmbx-form" method="post" action="' + esc(contactAction()) + '" accept-charset="UTF-8" data-act="signup-form" novalidate>' +
      '<input type="hidden" name="form_type" value="customer">' +
      '<input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="contact[tags]" value="' + esc(CAPTURE_TAGS) + '">' +
      '<input type="email" name="contact[email]" inputmode="email" placeholder="you@email.com" aria-label="Email address" autocomplete="email" required value="' + esc(restoredEmail) + '"' + (restoreError ? ' class="is-error"' : '') + '>' +
      '<button class="fmbx-btn" type="submit"><span>' + esc(btnLabel) + '</span></button>' +
    '</form>';
  }
  function captchaOn() { return !!(window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === 'function'); }
  function isBound(form) { return !!(form.getAttribute('data-hcaptcha-bound') || form.getAttribute('data-recaptcha-bound')); }
  function protectForm(form) { try { if (captchaOn() && !form.getAttribute('data-cptcha')) Shopify.captcha.protect(form); } catch (e) {} }
  function bindSignup(form, mode, onMsg) {
    var input = form.querySelector('input[name="contact[email]"]');
    var btn = form.querySelector('button[type="submit"]');
    var lbl = btn ? btn.querySelector('span') : null;
    var label = lbl ? lbl.textContent : '';
    function setLbl(t) { if (lbl) lbl.textContent = t; }
    function resetBtn() { if (btn) { btn.disabled = false; setLbl(label); } }
    protectForm(form);
    if (input) input.addEventListener('input', function () {
      if (onMsg) onMsg('');
      input.classList.remove('is-error');
      var v = (input.value || '').trim();
      if (v) savePending(mode, v, false);
    });
    /* capture phase on the form itself: runs before the hCaptcha handler and Shopify's own handler,
       so a bad address never reaches either of them. */
    form.addEventListener('submit', function (e) {
      var v = ((input && input.value) || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (input) input.classList.add('is-error');
        if (onMsg) onMsg('Please enter a valid email address.');
        return;
      }
      if (onMsg) onMsg('');
      savePending(mode, v, true);
      if (!captchaOn() || isBound(form)) {
        if (btn) { btn.disabled = true; setLbl('Sending…'); }
        setTimeout(resetBtn, 9000);
        return; /* hCaptcha and Shopify take it from here: token, then a native POST */
      }
      e.preventDefault(); e.stopImmediatePropagation();
      if (form.getAttribute('data-bs-waiting')) return;
      form.setAttribute('data-bs-waiting', '1');
      protectForm(form);
      if (btn) { btn.disabled = true; setLbl('One moment…'); }
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (isBound(form)) {
          clearInterval(t); form.removeAttribute('data-bs-waiting'); resetBtn();
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        } else if (tries >= 60) {
          clearInterval(t); form.removeAttribute('data-bs-waiting'); resetBtn();
          if (onMsg) onMsg('Our sign-up check did not load. Please try again, or pause an ad blocker for this page.');
        }
      }, 150);
    }, true);
  }
  function cleanUrl() {
    try {
      var u = new URL(location.href);
      ['customer_posted', 'contact_posted', 'form_key', 'form_type'].forEach(function (k) { u.searchParams.delete(k); });
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  /* A coffee pinned to a personality in the theme editor wins over the scoring, as long as it is
     in the pool, available, not a bundle and not a drip box (19 Oct 2026). */
  function pinned(profileId, excludeHandle) {
    var h = PINS[profileId];
    if (!h) return null;
    for (var i = 0; i < POOL.length; i++) {
      var p = POOL[i];
      if (p.id === h && p.id !== excludeHandle && !p.bundle && p.available !== false && !isDrip(p)) return p;
    }
    return null;
  }
  function computeMatch() {
    result = scoreQuiz(answers);
    heroP = pinned(result, null) || bestProduct(result, null);
    heroV = heroP ? pickVariant(heroP) : null;
    runnerId = PROFILES[result].runnerUp;
    runnerP = pinned(runnerId, heroP ? heroP.id : null) || bestProduct(runnerId, heroP ? heroP.id : null);
    if (runnerP && heroP && runnerP.id === heroP.id) runnerP = null;
  }
  /* Back from Shopify. ?customer_posted=true is the ONLY confirmed sign-up. Anything else with a
     parked state resumes where the visitor was, email pre-filled. */
  function restoreFromPending() {
    var q = null;
    try { q = new URLSearchParams(location.search); } catch (e) { q = null; }
    var posted = !!q && q.get('customer_posted') === 'true';
    var p = ssGet(PENDING_KEY), rv = ssGet(REVEALED_KEY);
    var src = isFresh(p) ? p : (isFresh(rv) ? rv : null);
    if (!src) return null;
    answers = src.answers || {};
    restoredEmail = src.email || '';
    if (!QUESTIONS.every(function (qq) { return answers[qq.id]; })) { answers = {}; restoredEmail = ''; return null; }
    computeMatch();
    if (!heroP) { ssDel(PENDING_KEY); ssDel(REVEALED_KEY); answers = {}; result = null; restoredEmail = ''; return null; }
    if (src === p && posted) {
      ssDel(PENDING_KEY);
      ssSet(REVEALED_KEY, { answers: answers, email: restoredEmail, path: location.pathname, ts: Date.now() });
      noteSent = true;
      if (MODE === 'gated') track('QuizEmailCapture', { personality: result, match: heroP ? heroP.name : null });
      cleanUrl();
      fresh = MODE === 'gated';
      return 'result';
    }
    if (src === rv) { noteSent = true; return 'result'; }
    if (p && p.submitted) restoreError = 'We couldn’t confirm that email yet. Please check it and try again.';
    return MODE === 'gated' ? 'profile' : 'result';
  }

  /* ---------- illustrations ---------- */
  var ART = {
    espresso: '<rect class="fl" x="12" y="8" width="48" height="12" rx="5"/><rect class="fw ln" x="25" y="19" width="22" height="7" rx="2.5"/><path class="ln" d="M25 22.5H13"/><ellipse class="fc drop" cx="33" cy="31" rx="1.7" ry="2.3"/><ellipse class="fc drop" cx="39" cy="31" rx="1.7" ry="2.3"/><path class="fw ln" d="M22 42h28v6a12 12 0 0 1-12 12h-4a12 12 0 0 1-12-12z"/><path class="ln" d="M50 45h3a4.5 4.5 0 0 1 0 9h-2"/><path class="ln" d="M15 64h42"/>',
    pourover: '<g class="wob"><path class="fl" d="M44 6h14a4 4 0 0 1 4 4v8a6 6 0 0 1-6 6H46a6 6 0 0 1-6-6v-8a4 4 0 0 1 4-4z"/><path class="ln" d="M40 15c-5 0-8-1-11 2"/><path class="ln" d="M62 11c4 0 5 3 5 5s-1 5-5 5"/></g><svg class="pourw" x="25" y="18.5" width="8" height="10" viewBox="25 18.5 8 10"><path class="ln pour" d="M29 13v20"/></svg><path class="fw ln" d="M16 30h40l-12 14H28z"/><path class="fw ln" d="M24 48h24v10a6 6 0 0 1-6 6H30a6 6 0 0 1-6-6z"/><path class="fc" d="M26.5 56h19v2a3.5 3.5 0 0 1-3.5 3.5H30a3.5 3.5 0 0 1-3.5-3.5z"/><ellipse class="fc drop" cx="36" cy="45.5" rx="1.6" ry="2.2"/>',
    dripbag: '<g class="bob"><path class="fp ln" d="M24 10h24v26H24z"/><path class="ln" d="M24 20l-6 14M48 20l6 14"/><path class="ln" d="M30 17h12"/></g><path class="fw ln" d="M14 34h40v14a14 14 0 0 1-14 14H28a14 14 0 0 1-14-14z"/><path class="ln" d="M54 38h3a6 6 0 0 1 0 12h-3"/>',
    frenchpress: '<rect class="fw ln" x="20" y="18" width="30" height="44" rx="5"/><rect class="fc" x="22.6" y="34" width="24.8" height="25.6" rx="3"/><g class="plunger"><path class="ln" d="M35 4v22"/><rect class="fl" x="29" y="2.5" width="12" height="5" rx="2.5"/><path class="ln" d="M23 26h24"/></g><path class="ln" d="M17 18h36"/><path class="ln" d="M50 26h5a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4h-5"/><path class="ln" d="M24 66h22"/>',
    fruit: '<g class="bob"><path class="ln" d="M27 35c1-10 6-18 12-23M45 37c0-9-2-17-6-25"/><path class="fp ln wob" d="M39 12c5-6 14-6 18-1-5 5-13 6-18 1z"/><circle class="fl" cx="26" cy="46" r="11"/><circle class="fl" cx="46" cy="48" r="11"/><circle class="fw" cx="22" cy="42" r="2.6"/><circle class="fw" cx="42" cy="44" r="2.6"/></g>',
    cocoa: '<g class="wob"><path class="fc" d="M14 16h31c0 5 4 9 9 9h4v31H14z"/><path class="d" d="M26 16v40M38 16v40M50 25v31M14 29h44M14 43h44"/></g>',
    nut: '<g class="bob"><path class="fp ln" d="M28 10c10 7 14 21 9 34-2 6-9 8-13 3-6-8-6-27 4-37z"/><path class="ln" d="M28 17c2 10 2 19-2 27"/></g><g class="bob2"><path class="fc ln" d="M49 22c8 8 10 20 4 31-3 5-9 6-12 1-4-8-2-23 8-32z"/><path class="ln" d="M48.5 29c0 9-1 16-5 23"/></g>',
    floral: '<path class="ln" d="M36 44v22M36 59c-6-1-10-5-11-10 6 0 10 4 11 10z"/><g class="spin"><ellipse class="fw ln" cx="36" cy="18" rx="6.5" ry="11"/><ellipse class="fw ln" cx="36" cy="18" rx="6.5" ry="11" transform="rotate(72 36 30)"/><ellipse class="fw ln" cx="36" cy="18" rx="6.5" ry="11" transform="rotate(144 36 30)"/><ellipse class="fw ln" cx="36" cy="18" rx="6.5" ry="11" transform="rotate(216 36 30)"/><ellipse class="fw ln" cx="36" cy="18" rx="6.5" ry="11" transform="rotate(288 36 30)"/></g><circle class="fp ln" cx="36" cy="30" r="5"/>',
    compass: '<circle class="fw ln" cx="36" cy="36" r="26"/><circle class="ln" cx="36" cy="36" r="19" stroke-dasharray="1.5 4.5"/><path class="ln" d="M36 8v5M36 59v5M8 36h5M59 36h5"/><g class="needle"><path class="fl" d="M36 15l6 21H30z"/><path class="fc" d="M36 57l-6-21h12z"/></g><circle class="fw ln" cx="36" cy="36" r="3.4"/>',
    anchor: '<circle class="fw ln" cx="34" cy="38" r="26"/><path class="ln" d="M50 34h9a4 4 0 0 1 0 8h-9"/><circle class="fw ln" cx="34" cy="38" r="17"/><circle class="fc" cx="34" cy="38" r="14"/><path class="fw heart" d="M34 47c-6.5-4.2-9.5-7.9-7.2-11 1.8-2.4 5.2-1.9 7.2.9 2-2.8 5.4-3.3 7.2-.9 2.3 3.1-.7 6.8-7.2 11z"/>'
  };
  function art(name) { return '<svg viewBox="0 0 72 72" aria-hidden="true" focusable="false">' + (ART[name] || '') + '</svg>'; }
  var BADGE = {
    compass: '<circle cx="12" cy="12" r="9"/><path d="M15.5 8.5l-2 5-5 2 2-5z"/>',
    bean: '<path d="M12 3c-4 0-7 4-7 9s3 9 7 9 7-4 7-9-3-9-7-9z"/><path d="M12.6 4.2c-2.4 3 1.6 6-.9 9-1.3 1.6-.9 4 .4 6"/>',
    heart: '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>',
    mug: '<path d="M4 10h12v5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5z"/><path d="M16 11h1.5a2.5 2.5 0 0 1 0 5H16"/><path d="M8 3.5c0 1.5 1 1.5 1 3M12 3.5c0 1.5 1 1.5 1 3"/>',
    moon: '<path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z"/>'
  };
  function badgeHTML(prof) {
    var id = nid('fmbx-ring-');
    return '<div class="fmbx-badge" aria-hidden="true">' +
      '<svg class="fmbx-badge__ring" viewBox="0 0 120 120" focusable="false"><defs><path id="' + id + '" d="M60 60m-48 0a48 48 0 1 1 96 0a48 48 0 1 1-96 0"/></defs>' +
      '<text><textPath href="#' + id + '" textLength="298" lengthAdjust="spacing">YOUR COFFEE PERSONALITY · BEAN SHIPPER ·</textPath></text></svg>' +
      '<span class="fmbx-badge__core"><svg viewBox="0 0 24 24" focusable="false">' + (BADGE[prof.icon] || BADGE.bean) + '</svg></span></div>';
  }
  var BEAN_SVG = '<svg viewBox="0 0 40 52" aria-hidden="true" focusable="false"><path class="b" d="M20 2C8.5 2 2 13.8 2 26.2 2 39.5 9.6 50 20.4 50 31.6 50 38 38.3 38 25.6 38 12.7 31 2 20 2Z"/><path class="c" d="M21.5 6.5C15.5 14.5 25.5 22 19.5 30.5 16.6 34.6 17.6 41.2 20.5 45.5"/><ellipse class="hl" cx="12" cy="17" rx="4" ry="7" transform="rotate(20 12 17)"/></svg>';
  function words(text) {
    return String(text || '').split(' ').map(function (w, i) { return '<span class="fmbx-w"><span style="--i:' + i + '">' + esc(w) + '</span></span>'; }).join(' ');
  }

  /* ---------- stage, screens, transitions ---------- */
  var stage = qs(root, '[data-fmbx-stage]');
  var top = qs(root, '[data-fmbx-top]');
  var trail = qsa(root, '.fmbx-trail li');
  var countEl = qs(root, '[data-fmbx-count]');
  var live = qs(root, '[data-fmbx-live]');
  var fx = qs(root, '[data-fmbx-fx]');
  var intro = qs(root, '[data-fmbx-screen="intro"]');
  var cur = intro;
  var timers = [];
  function later(fn, ms) { var t = setTimeout(fn, ms); timers.push(t); return t; }
  function clearTimers() { timers.forEach(clearTimeout); timers = []; }
  function say(t) { if (live) { live.textContent = ''; setTimeout(function () { live.textContent = t; }, 40); } }
  function setTone(c) { if (c) root.style.setProperty('--tone', c); }
  function scrollToStage() {
    var r = root.getBoundingClientRect();
    if (r.top < -4) window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset), behavior: reduce ? 'auto' : 'smooth' });
  }
  function swap(el, dir, onIn) {
    var old = cur;
    cur = el;
    if (el !== intro) stage.appendChild(el);
    var instant = reduce || !old || !dir;
    if (instant) {
      if (old && old !== el) { if (old === intro) intro.hidden = true; else old.remove(); }
      el.hidden = false;
      el.classList.remove('is-from-right', 'is-from-left', 'is-to-left', 'is-to-right');
      if (onIn) onIn();
      return;
    }
    el.hidden = false;
    el.classList.remove('is-to-left', 'is-to-right');
    el.classList.add(dir > 0 ? 'is-from-right' : 'is-from-left');
    void el.offsetWidth;
    requestAnimationFrame(function () {
      el.classList.remove('is-from-right', 'is-from-left');
      if (old && old !== el) old.classList.add(dir > 0 ? 'is-to-left' : 'is-to-right');
    });
    setTimeout(function () {
      if (old && old !== el) {
        if (old === intro) { intro.hidden = true; intro.classList.remove('is-to-left', 'is-to-right'); }
        else if (old.parentNode) old.remove();
      }
      if (onIn) onIn();
    }, 780);
  }
  function makeScreen(cls, labelId) {
    var el = document.createElement('section');
    el.className = 'fmbx-screen ' + cls;
    if (labelId) el.setAttribute('aria-labelledby', labelId);
    return el;
  }
  function focusHead(el) {
    var h = qs(el, '[data-fmbx-head]');
    if (h) { try { h.focus({ preventScroll: true }); } catch (e) {} }
  }
  function showTop(on) { if (top) top.hidden = !on; }
  function paintTrail(i) {
    trail.forEach(function (li, k) {
      li.classList.toggle('is-done', k < i);
      li.classList.toggle('is-now', k === i);
    });
    if (countEl) countEl.textContent = 'Question ' + (i + 1) + ' of ' + N;
  }

  /* ---------- particles (transform-only, removed when done) ---------- */
  var BEANS = ['#4A2A1E', '#6B3B22', '#3A2218', '#5A3424'];
  var CONF = ['#B61F2E', '#D52F3E', '#F2B36B', '#F29A7B', '#6B3B22', '#3A2218'];
  function particle(x0, y0, x1, y1, o) {
    if (reduce || !fx || !fx.animate) return;
    var p = document.createElement('i');
    p.className = 'fmbx-p' + (o.dot ? ' is-dot' : '');
    p.style.setProperty('--s', (o.size || 10) + 'px');
    p.style.setProperty('--c', o.color || BEANS[0]);
    fx.appendChild(p);
    var mx = (x0 + x1) / 2 + (o.bend || 0), my = Math.min(y0, y1) - (o.lift || 60);
    var r0 = o.rot0 || 0, r1 = o.rot || 360;
    var a = p.animate([
      { transform: 'translate3d(' + x0 + 'px,' + y0 + 'px,0) rotate(' + r0 + 'deg) scale(' + (o.s0 || 1) + ')' },
      { transform: 'translate3d(' + mx + 'px,' + my + 'px,0) rotate(' + (r0 + r1 / 2) + 'deg) scale(' + (o.s1 || 1) + ')', offset: o.mid || 0.45 },
      { transform: 'translate3d(' + x1 + 'px,' + y1 + 'px,0) rotate(' + (r0 + r1) + 'deg) scale(' + (o.s2 == null ? 0.25 : o.s2) + ')' }
    ], { duration: o.dur || 700, delay: o.delay || 0, easing: o.ease || 'cubic-bezier(.3,.6,.3,1)', fill: 'both' });
    a.onfinish = function () { if (p.parentNode) p.remove(); };
  }
  function cartTarget() {
    var c = qsa(document, '[data-bs-cart-badge], header a[href$="/cart"], a[href$="/cart"]');
    for (var i = 0; i < c.length; i++) { var r = c[i].getBoundingClientRect(); if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight) return c[i]; }
    return null;
  }
  function rect(el) { var r = el.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2, w: r.width, h: r.height }; }
  function beanTrailBurst(x, y, li) {
    if (reduce || !li) return;
    var t = rect(li);
    for (var k = 0; k < 9; k++) {
      var sx = x + ((k * 37) % 23 - 11), sy = y + ((k * 53) % 19 - 9);
      particle(sx, sy, t.x, t.y, { size: 8 + (k % 3) * 2, color: BEANS[k % BEANS.length], bend: (k % 2 ? 1 : -1) * (40 + k * 9), lift: 70 + (k % 4) * 25, rot: 300 + k * 40, dur: 620 + k * 28, delay: k * 18, s2: 0.35 });
    }
  }
  function confetti(el, n) {
    if (reduce || !el) return;
    var c = rect(el), W = window.innerWidth, H = window.innerHeight;
    n = n || 34;
    for (var k = 0; k < n; k++) {
      var ang = (k / n) * Math.PI * 2 + (k % 3) * 0.21;
      var dist = 120 + (k * 47) % 160;
      var tx = c.x + Math.cos(ang) * dist, ty = c.y + Math.sin(ang) * dist * 0.75 + 120 + (k % 5) * 30;
      tx = clamp(tx, -20, W + 20); ty = clamp(ty, -20, H + 40);
      var bean = k % 3 !== 0;
      particle(c.x, c.y, tx, ty, { size: bean ? 10 + (k % 4) * 2 : 7 + (k % 3), dot: !bean, color: bean ? BEANS[k % BEANS.length] : CONF[k % CONF.length], bend: Math.cos(ang) * 40, lift: 90 + (k % 6) * 30, mid: 0.35, rot: (k % 2 ? 1 : -1) * (360 + k * 25), dur: 1100 + (k % 7) * 90, delay: (k % 6) * 25, s0: 0.4, s1: 1.15, s2: 0.2, ease: 'cubic-bezier(.2,.8,.3,1)' });
    }
  }
  var toastT = null, toastEl = null;
  function toast(msg) {
    if (!fx) return;
    if (!toastEl) { toastEl = document.createElement('p'); toastEl.className = 'fmbx-toast'; toastEl.setAttribute('role', 'status'); fx.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2400);
  }

  /* ---------- intro: the orbit of bags ---------- */
  (function orbit() {
    var wrap = qs(intro, '[data-fmbx-orbit]');
    var list = qsa(wrap, '[data-fmbx-obag]');
    if (!wrap || !list.length || reduce) return;
    var n = list.length, rx = 150, ry = 46, running = false, seen = true, t0 = performance.now(), tx = 0, ty = 0, px = 0, py = 0;
    function dims() { var cs = getComputedStyle(wrap); rx = parseFloat(cs.getPropertyValue('--rx')) || 150; ry = parseFloat(cs.getPropertyValue('--ry')) || 46; }
    dims();
    window.addEventListener('resize', dims);
    wrap.classList.add('is-live');
    function frame(now) {
      if (!running) return;
      var a0 = ((now - t0) / 14000) * Math.PI * 2;
      px += (tx - px) * 0.06; py += (ty - py) * 0.06;
      for (var i = 0; i < n; i++) {
        var a = a0 + (i / n) * Math.PI * 2;
        var d = (Math.sin(a) + 1) / 2;
        var x = Math.cos(a) * rx + px * d * 16, y = Math.sin(a) * ry - 18 + py * d * 10;
        list[i].style.transform = 'translate(-50%,-50%) translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotate(' + (Math.cos(a) * -7).toFixed(2) + 'deg) scale(' + (0.6 + d * 0.48).toFixed(3) + ')';
        list[i].style.zIndex = String(1 + Math.round(d * 20));
      }
      requestAnimationFrame(frame);
    }
    function go() { var on = seen && !intro.hidden && document.visibilityState !== 'hidden'; if (on && !running) { running = true; requestAnimationFrame(frame); } else if (!on) running = false; }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; go(); }).observe(wrap);
    document.addEventListener('visibilitychange', go);
    root.addEventListener('fmbx:screen', go);
    if (fine) intro.addEventListener('pointermove', function (e) { tx = (e.clientX / window.innerWidth - 0.5) * 2; ty = (e.clientY / window.innerHeight - 0.5) * 2; });
    go();
  })();
  function screenEvent() { try { root.dispatchEvent(new CustomEvent('fmbx:screen')); } catch (e) {} }

  /* ---------- questions ---------- */
  function optCardHTML(o, k, q) {
    var was = answers[q.id] === o.id;
    return '<button type="button" class="fmbx-opt' + (was ? ' is-was' : '') + '" data-opt="' + esc(o.id) + '" style="--i:' + k + '" aria-pressed="' + (was ? 'true' : 'false') + '">' +
      '<span class="fmbx-opt__k" aria-hidden="true">' + 'ABCD'.charAt(k) + '</span>' +
      '<span class="fmbx-opt__art fmbx-art">' + art(o.icon) + '</span>' +
      '<span class="fmbx-opt__l">' + esc(o.label) + '</span>' +
      '<span class="fmbx-opt__d">' + esc(o.desc) + '</span>' +
    '</button>';
  }
  function roastHTML(q) {
    var prev = answers[q.id];
    var stops = q.options.map(function (o, k) {
      return '<button type="button" class="fmbx-stop' + (prev === o.id ? ' is-was' : '') + '" data-opt="' + esc(o.id) + '" data-t="' + (k / (q.options.length - 1)) + '" aria-pressed="' + (prev === o.id ? 'true' : 'false') + '"><b>' + esc(o.label) + '</b><span>' + esc(o.desc) + '</span></button>';
    }).join('');
    return '<div class="fmbx-roast" data-fmbx-roast>' +
      '<div class="fmbx-bean" aria-hidden="true"><span class="fmbx-bean__smoke"><i></i><i></i><i></i></span>' + BEAN_SVG + '</div>' +
      '<div class="fmbx-track" role="slider" tabindex="0" aria-label="Roast level" aria-valuemin="0" aria-valuemax="2" aria-valuenow="1" aria-valuetext="Medium" data-fmbx-track><span class="fmbx-track__bar"></span><span class="fmbx-track__knob"></span></div>' +
      '<div class="fmbx-stops" role="group" aria-label="Roast">' + stops + '</div>' +
      '<p class="fmbx-hint">Drag the knob or tap a roast.</p>' +
    '</div>';
  }
  function questionScreen(i) {
    var q = QUESTIONS[i];
    var hid = nid('fmbx-qh-');
    var el = makeScreen('fmbx-qs', hid);
    el.setAttribute('data-q', String(i));
    el.innerHTML = '<div class="fmbx-wrap fmbx-q">' +
      '<div class="fmbx-q__head"><p class="fmbx-eyebrow">0' + (i + 1) + ' · ' + esc(q.cat) + '</p>' +
      '<h2 class="fmbx-h2" id="' + hid + '" tabindex="-1" data-fmbx-head>' + esc(q.q) + '</h2><p class="fmbx-p2">' + esc(q.sub) + '</p></div>' +
      (q.layout === 'roast' ? roastHTML(q) : '<div class="fmbx-opts' + (q.options.length === 2 ? ' fmbx-opts--2' : '') + '" role="group" aria-labelledby="' + hid + '">' + q.options.map(function (o, k) { return optCardHTML(o, k, q); }).join('') + '</div>') +
    '</div>';
    qsa(el, '.fmbx-opt').forEach(function (b) {
      b.addEventListener('click', function (e) { choose(i, b.getAttribute('data-opt'), b, e); });
      if (fine) {
        b.addEventListener('pointermove', function (e) {
          var r = b.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          b.style.setProperty('--ry', ((x - 0.5) * 10).toFixed(2) + 'deg');
          b.style.setProperty('--rx', ((0.5 - y) * 10).toFixed(2) + 'deg');
        });
        b.addEventListener('pointerleave', function () { b.style.setProperty('--rx', '0deg'); b.style.setProperty('--ry', '0deg'); });
      }
    });
    if (q.layout === 'roast') bindRoast(el, i);
    return el;
  }
  function showQuestion(i, dir) {
    step = i;
    var q = QUESTIONS[i];
    showTop(true);
    paintTrail(i);
    if (q.layout !== 'roast') setTone(q.tone);
    var el = questionScreen(i);
    busy = !(reduce || !dir);
    if (busy) setTimeout(function () { busy = false; }, 430);
    swap(el, dir, function () { focusHead(el); screenEvent(); });
    say('Question ' + (i + 1) + ' of ' + N + ': ' + q.q);
    scrollToStage();
    screenEvent();
  }
  function choose(i, optId, btn, e) {
    if (busy || step !== i) return;
    var q = QUESTIONS[i];
    busy = true;
    answers[q.id] = optId;
    var group = qsa(btn.parentNode, '[data-opt]');
    group.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); if (b !== btn) b.classList.add('is-dim'); b.classList.remove('is-was'); });
    var r = btn.getBoundingClientRect();
    var x = e && e.clientX ? e.clientX : r.left + r.width / 2, y = e && e.clientY ? e.clientY : r.top + r.height / 2;
    btn.style.setProperty('--px', ((x - r.left) / r.width * 100).toFixed(1) + '%');
    btn.style.setProperty('--py', ((y - r.top) / r.height * 100).toFixed(1) + '%');
    btn.classList.add('is-picked');
    beanTrailBurst(x, y, trail[i]);
    later(function () { if (trail[i]) { trail[i].classList.add('is-done', 'is-pop'); } }, reduce ? 0 : 520);
    later(function () {
      if (trail[i]) trail[i].classList.remove('is-pop');
      busy = false;
      if (i < N - 1) showQuestion(i + 1, 1); else toBrewing();
    }, reduce ? 120 : 760);
  }
  var ROAST_RAMP = [[0, '#E4C49A'], [0.25, '#C9A06A'], [0.5, '#8A5333'], [0.75, '#4A2A1E'], [1, '#24130D']];
  function bindRoast(el, i) {
    var q = QUESTIONS[i];
    var box = qs(el, '[data-fmbx-roast]'), track = qs(el, '[data-fmbx-track]'), bean = qs(el, '.fmbx-bean');
    var stops = qsa(el, '.fmbx-stop');
    var prev = answers[q.id], t = 0.5;
    q.options.forEach(function (o, k) { if (o.id === prev) t = k / (q.options.length - 1); });
    var dragging = false, moved = false;
    function nearest(v) { var k = Math.round(v * (q.options.length - 1)); return clamp(k, 0, q.options.length - 1); }
    function paint(v, snapping) {
      t = clamp(v, 0, 1);
      var c = ramp(ROAST_RAMP, t);
      box.style.setProperty('--bean', c);
      box.style.setProperty('--t', t.toFixed(4));
      box.style.setProperty('--smoke', clamp((t - 0.42) / 0.58, 0, 1).toFixed(3));
      if (bean) bean.style.transform = 'rotate(' + ((t - 0.5) * 18).toFixed(2) + 'deg) scale(' + (0.96 + Math.abs(t - 0.5) * 0.12).toFixed(3) + ')';
      setTone(mix('#F2C79A', '#B9805A', t));
      var k = nearest(t);
      stops.forEach(function (s, j) { s.classList.toggle('is-near', j === k); });
      track.setAttribute('aria-valuenow', String(k));
      track.setAttribute('aria-valuetext', q.options[k].label);
      track.classList.toggle('is-drag', dragging && !snapping);
    }
    function fromX(cx) {
      var bar = qs(track, '.fmbx-track__bar').getBoundingClientRect();
      return (cx - bar.left) / Math.max(1, bar.width);
    }
    function commit() {
      var k = nearest(t);
      paint(k / (q.options.length - 1), true);
      var knob = qs(track, '.fmbx-track__knob');
      var kr = knob.getBoundingClientRect();
      choose(i, q.options[k].id, stops[k], { clientX: kr.left + kr.width / 2, clientY: kr.top + kr.height / 2 });
    }
    track.addEventListener('pointerdown', function (e) {
      if (busy) return;
      dragging = true; moved = false;
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
      paint(fromX(e.clientX));
      e.preventDefault();
    });
    track.addEventListener('pointermove', function (e) { if (!dragging) return; moved = true; paint(fromX(e.clientX)); });
    function up() { if (!dragging) return; dragging = false; track.classList.remove('is-drag'); commit(); }
    track.addEventListener('pointerup', up);
    track.addEventListener('pointercancel', function () { dragging = false; track.classList.remove('is-drag'); paint(nearest(t) / (q.options.length - 1), true); });
    track.addEventListener('keydown', function (e) {
      var k = nearest(t), last = q.options.length - 1;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { k = clamp(k - 1, 0, last); }
      else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { k = clamp(k + 1, 0, last); }
      else if (e.key === 'Home') k = 0;
      else if (e.key === 'End') k = last;
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); commit(); return; }
      else return;
      e.preventDefault(); e.stopPropagation();
      paint(k / last, true);
    });
    stops.forEach(function (s, k) {
      s.addEventListener('click', function (e) { paint(k / (q.options.length - 1), true); choose(i, s.getAttribute('data-opt'), s, e); });
      if (fine) s.addEventListener('pointerenter', function () { if (!busy) paint(k / (q.options.length - 1), true); });
    });
    paint(t, true);
  }
  document.addEventListener('keydown', function (e) {
    if (typeof step !== 'number' || busy) return;
    var tg = e.target;
    if (tg && (/^(INPUT|TEXTAREA|SELECT)$/.test(tg.tagName) || tg.isContentEditable)) return;
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    if (tg && tg.closest && tg.closest('[data-fmbx-track]')) return;
    if (!cur || !root.contains(cur)) return;
    var q = QUESTIONS[step];
    var key = String(e.key || '').toLowerCase();
    var k = '1234'.indexOf(key); if (k < 0) k = 'abcd'.indexOf(key);
    if (k >= 0 && k < q.options.length) {
      var b = qs(cur, '[data-opt="' + q.options[k].id + '"]');
      if (b) { e.preventDefault(); if (q.layout === 'roast') b.click(); else choose(step, q.options[k].id, b, null); }
      return;
    }
    if (key === 'escape' || key === 'backspace') { e.preventDefault(); goBack(); }
  });
  function goBack() {
    if (busy) return;
    clearTimers();
    busy = false;
    if (typeof step === 'number' && step > 0) showQuestion(step - 1, -1);
    else if (step === 0) showIntro(-1);
  }
  var backBtn = qs(root, '[data-fmbx-back]');
  if (backBtn) backBtn.addEventListener('click', goBack);

  function showIntro(dir) {
    step = 'intro';
    showTop(false);
    setTone('#F29A7B');
    intro.hidden = false;
    swap(intro, dir, function () { screenEvent(); var h = qs(intro, '.fmbx-h1'); if (h) { h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: true }); } catch (e) {} } });
    scrollToStage();
    screenEvent();
  }
  var startBtn = qs(intro, '[data-fmbx-start]');
  if (startBtn) startBtn.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    if (!reduce) {
      var r = startBtn.getBoundingClientRect();
      for (var k = 0; k < 10; k++) particle(r.left + r.width / 2, r.top + r.height / 2, r.left + r.width / 2 + Math.cos(k / 10 * 6.283) * 120, r.top + r.height / 2 + Math.sin(k / 10 * 6.283) * 90, { size: 9, color: BEANS[k % 4], lift: 30, rot: 280, dur: 640, s2: 0 });
    }
    answers = {};
    trail.forEach(function (li) { li.classList.remove('is-done', 'is-now'); });
    showQuestion(0, 1);
  });

  /* ---------- brewing ---------- */
  var BREW_SVG = '<svg class="fmbx-brew__art" viewBox="0 0 280 220" aria-hidden="true" focusable="false">' +
    '<defs><clipPath id="fmbx-carafe-clip"><path d="M104 132h72l-6 64a12 12 0 0 1-12 11h-36a12 12 0 0 1-12-11z"/></clipPath></defs>' +
    '<g transform="rotate(-16 72 66)"><path d="M40 46h52a8 8 0 0 1 8 8v28a14 14 0 0 1-14 14H46a14 14 0 0 1-14-14V54a8 8 0 0 1 8-8z" fill="#B61F2E"/><path class="ln" d="M100 62c16 0 24-9 32-22"/><path class="ln" d="M32 58c-11 0-15 6-15 12s4 12 15 12"/><rect x="56" y="38" width="20" height="8" rx="3" fill="#1B1716"/></g>' +
    '<path class="stream" d="M136 50C139 68 140 84 140 104"/>' +
    '<path class="ln" fill="#fff" d="M106 104h68l-22 26h-24z"/><path class="ln" d="M100 104h80"/>' +
    '<circle class="dr" cx="140" cy="134" r="3"/>' +
    '<g clip-path="url(#fmbx-carafe-clip)"><rect class="liq" x="96" y="152" width="88" height="70"/><rect class="crema" x="96" y="148" width="88" height="5"/></g>' +
    '<path class="ln" d="M104 132h72l-6 64a12 12 0 0 1-12 11h-36a12 12 0 0 1-12-11z"/>' +
    '<path class="steam" d="M196 150c-6-8 6-12 0-22"/><path class="steam" d="M212 156c-6-8 6-12 0-22"/>' +
  '</svg>';
  function toBrewing() {
    computeMatch();
    track('QuizComplete', { personality: result, match: heroP ? heroP.name : null });
    step = 'brewing';
    showTop(false);
    setTone(PROFILES[result].tone);
    var el = makeScreen('fmbx-brewing');
    el.innerHTML = '<div class="fmbx-wrap fmbx-brew">' + BREW_SVG + '<p class="fmbx-brew__txt" data-fmbx-brewtxt><span>Weighing your answers</span></p><div class="fmbx-dots" aria-hidden="true"><i></i><i></i><i></i></div></div>';
    swap(el, 1);
    say('Matching your coffee');
    scrollToStage();
    var lines = ['Matching the roast', 'Pouring your result'];
    var tx = qs(el, '[data-fmbx-brewtxt]');
    if (!reduce) lines.forEach(function (l, k) { later(function () { if (tx) tx.innerHTML = '<span>' + esc(l) + '</span>'; }, 900 + k * 800); });
    later(function () {
      fresh = true;
      if (MODE === 'gated') showProfile(1); else showResult(1);
    }, reduce ? 500 : 2600);
  }

  /* ---------- the coffee card (reveal and gated result) ---------- */
  function variantUI(p) {
    var opts = (p.opts || []).map(function (o, i) { return { name: typeof o === 'string' ? o : (o && o.name) || ('Option ' + (i + 1)), i: i }; });
    var vs = (p.variants || []).filter(function (v) { return v && v.id; });
    function val(v, i) { return v.o && v.o[i] != null ? v.o[i] : null; }
    var values = opts.map(function (o) {
      var seen = [];
      vs.forEach(function (v) { var x = val(v, o.i); if (x != null && seen.indexOf(x) < 0) seen.push(x); });
      return seen;
    });
    var sizeIdx = -1, grindIdx = -1;
    opts.forEach(function (o) { if (sizeIdx < 0 && values[o.i].length && grams(values[o.i][0]) >= 15) sizeIdx = o.i; });
    opts.forEach(function (o) { if (grindIdx < 0 && o.i !== sizeIdx && /grind|prep|type/i.test(o.name)) grindIdx = o.i; });
    return { opts: opts, vs: vs, val: val, values: values, sizeIdx: sizeIdx, grindIdx: grindIdx };
  }
  function cardHTML(p) {
    var u = variantUI(p);
    var start = heroV && heroV.o ? heroV : null;
    if (!start) u.vs.forEach(function (v) { if (!start && v.available !== false) start = v; });
    if (!start) start = u.vs[0];
    var notes = noteChips(p);
    var own = isOwn(p);
    var meta = [p.origin_label, p.kind && p.origin_label && p.origin_label.toLowerCase().indexOf(String(p.kind).toLowerCase()) > -1 ? '' : p.kind].filter(Boolean).join(' · ');
    var you = { light: 0.1, medium: 0.5, dark: 0.9 }[answers.roast];
    var itPos = roastPos(p.roast_meta || p.match_roast);
    var img = p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.name) + '" width="900" height="1117" loading="eager">' : '';
    var h = '<article class="fmbx-card" style="--tone:' + esc(p.tone || '#F29A7B') + '" data-fmbx-card>' +
      '<div class="fmbx-card__stage">' +
        '<span class="fmbx-card__tag">Your match</span><span class="fmbx-card__disc" aria-hidden="true"></span>' +
        '<div class="fmbx-card__float"><a class="fmbx-card__bag' + (p.cut ? '' : ' is-photo') + '" href="' + esc(p.url) + '" tabindex="-1" data-fmbx-bag>' + img + '</a></div>' +
        (notes[0] ? '<span class="fmbx-chip fmbx-chip--a" aria-hidden="true"><i></i>' + esc(notes[0]) + '</span>' : '') +
        (notes[1] ? '<span class="fmbx-chip fmbx-chip--b" aria-hidden="true"><i></i>' + esc(notes[1]) + '</span>' : '') +
        (notes[2] ? '<span class="fmbx-chip fmbx-chip--c" aria-hidden="true"><i></i>' + esc(notes[2]) + '</span>' : '') +
      '</div>' +
      (meta ? '<p class="fmbx-card__meta">' + esc(meta) + '</p>' : '') +
      '<h2 class="fmbx-card__name prodcard__name"><a href="' + esc(p.url) + '">' + esc(p.name) + '</a></h2>' +
      (notes.length ? '<p class="fmbx-card__notes">' + esc(notes.join(' · ')) + '</p>' : '') +
      (you != null ? '<div class="fmbx-meter"><div class="fmbx-meter__bar" role="img" aria-label="Your roast: ' + esc(cap(answers.roast)) + '. This coffee: ' + esc(roastName(p)) + '"><span class="fmbx-meter__pin is-it" style="--x:' + itPos + '"></span><span class="fmbx-meter__pin is-you" style="--x:' + you + '"></span></div><p class="fmbx-meter__l"><span><b>You</b> · ' + esc(cap(answers.roast)) + '</span><span><b>This coffee</b> · ' + esc(roastName(p)) + '</span></p></div>' : '');
    h += '<form class="fmbx-buy" action="' + esc(BASE + 'cart/add') + '" method="post" enctype="multipart/form-data" data-bs-add>' +
      '<input type="hidden" name="id" value="' + esc(start ? start.id : p.variant_id) + '"><input type="hidden" name="quantity" value="1">';
    u.opts.forEach(function (o) {
      var isSize = o.i === u.sizeIdx;
      if (u.values[o.i].length < 2 && !isSize) return;
      if (isSize && u.values[o.i].length < 2) return;
      var label = isSize ? 'Size' : (/grind|prep/i.test(o.name) ? 'Grind' : o.name);
      h += '<fieldset class="fmbx-pick"><legend>' + esc(label) + '</legend><div class="fmbx-pick__row' + (isSize ? ' fmbx-pick__row--size' : '') + '" role="radiogroup" aria-label="' + esc(label) + '">';
      u.values[o.i].forEach(function (x) {
        var avail = u.vs.some(function (v) { return v.available !== false && u.val(v, o.i) === x; });
        if (isSize) h += '<button type="button" class="fmbx-c" role="radio" aria-checked="false" data-i="' + o.i + '" data-v="' + esc(x) + '"' + (avail ? '' : ' disabled') + '><b>' + esc(shortLabel(x)) + '</b><span class="p" data-p></span><small data-c></small></button>';
        else {
          var rec = o.i === u.grindIdx && String(x).toLowerCase().indexOf(GRIND_BY_BREW[answers.brew] || '~') > -1;
          h += '<button type="button" class="fmbx-c fmbx-c--pill" role="radio" aria-checked="false" data-i="' + o.i + '" data-v="' + esc(x) + '"' + (avail ? '' : ' disabled') + '>' + esc(x) + (rec ? '<em>for you</em>' : '') + '</button>';
        }
      });
      h += '</div></fieldset>';
    });
    h += '<p class="fmbx-buy__pc" data-pc></p>' +
      '<button type="submit" class="fmbx-btn" data-bs-pdp-add><span data-lbl>Add to bag</span><svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M5 10h10M11 6l4 4-4 4"/></svg></button>' +
      '<p class="fmbx-micro">' + (own ? 'Roasted to order \u00b7 ships within 24 hours of roasting \u00b7 ' : '') + esc(SHIP) + (SHIP ? '.' : '') + (own ? ' Not right? Free replacement.' : '') + '</p>' +
    '</form>' +
    '<a class="fmbx-link" href="' + esc(p.url) + '">See the full page, grinds and reviews <span aria-hidden="true">→</span></a>' +
    '</article>';
    return h;
  }
  function bindCard(card, p) {
    var form = qs(card, 'form[data-bs-add]');
    if (!form) return;
    var u = variantUI(p);
    var idIn = qs(form, 'input[name="id"]');
    var chips = qsa(form, '.fmbx-c');
    var pcEl = qs(form, '[data-pc]');
    var lbl = qs(form, '[data-lbl]');
    var add = qs(form, '[data-bs-pdp-add]');
    var start = null;
    u.vs.forEach(function (v) { if (!start && String(v.id) === String(idIn.value)) start = v; });
    if (!start) start = u.vs[0];
    var state = u.opts.map(function (o) { return start ? u.val(start, o.i) : null; });
    var first0 = u.sizeIdx >= 0 ? u.values[u.sizeIdx][0] : null, g0 = first0 ? grams(first0) : 0;
    function find(st, strict) {
      for (var i = 0; i < u.vs.length; i++) {
        var ok = true;
        for (var j = 0; j < st.length; j++) if (u.val(u.vs[i], j) !== st[j]) { ok = false; break; }
        if (ok && (!strict || u.vs[i].available !== false)) return u.vs[i];
      }
      return null;
    }
    function priceFor(i, x) {
      var best = 0;
      u.vs.forEach(function (v) {
        if (u.val(v, i) !== x) return;
        var same = true;
        for (var j = 0; j < state.length; j++) if (j !== i && j !== u.sizeIdx && u.val(v, j) !== state[j]) same = false;
        if (same && (!best || v.price < best)) best = v.price;
      });
      if (!best) u.vs.forEach(function (v) { if (u.val(v, i) === x && (!best || v.price < best)) best = v.price; });
      return best;
    }
    function paint() {
      var v = find(state, true) || find(state, false);
      if (!v) { if (lbl) lbl.textContent = 'Add to bag'; return; }
      state = u.opts.map(function (o) { return u.val(v, o.i); });
      idIn.value = v.id;
      heroV = v;
      chips.forEach(function (c) { c.setAttribute('aria-checked', state[+c.getAttribute('data-i')] === c.getAttribute('data-v') ? 'true' : 'false'); });
      if (u.sizeIdx >= 0) {
        var p0 = priceFor(u.sizeIdx, first0);
        chips.forEach(function (c) {
          if (+c.getAttribute('data-i') !== u.sizeIdx) return;
          var x = c.getAttribute('data-v'), pr = priceFor(u.sizeIdx, x), g = grams(x), cn = Math.floor(g / 15);
          var pe = qs(c, '[data-p]'), ce = qs(c, '[data-c]');
          if (pe) pe.textContent = pr ? money(pr) : '';
          if (ce) ce.textContent = cn ? money(Math.round(pr / cn)) + ' a cup' : '';
          var old = qs(c, '.sv'); if (old) old.remove();
          var nb = bags(x);
          if (nb > 1 && g0 && Math.abs(g / nb - g0) < 1 && p0) {
            var save = Math.floor((p0 * nb - pr) / 100);
            if (save > 0) { var sv = document.createElement('span'); sv.className = 'sv'; sv.textContent = 'Save RM' + save; c.appendChild(sv); }
          }
        });
        var gs = grams(state[u.sizeIdx]), cups = Math.floor(gs / 15);
        if (pcEl) pcEl.innerHTML = cups ? cups + ' cups at 15g · <b>' + money(Math.round(v.price / cups)) + '</b> a cup' : '';
      } else if (pcEl) {
        var gg = grams(v.title), cc = Math.floor(gg / 15);
        pcEl.innerHTML = cc ? cc + ' cups at 15g · <b>' + money(Math.round(v.price / cc)) + '</b> a cup' : '';
      }
      if (add) add.disabled = v.available === false;
      if (lbl) lbl.textContent = v.available === false ? 'Sold out' : 'Add to bag · ' + money(v.price);
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.disabled) return;
        var i = +c.getAttribute('data-i'), x = c.getAttribute('data-v');
        state[i] = x;
        if (!find(state, true)) {
          var alt = null;
          u.vs.forEach(function (v) { if (!alt && v.available !== false && u.val(v, i) === x) alt = v; });
          if (alt) state = u.opts.map(function (o) { return u.val(alt, o.i); });
        }
        paint();
      });
    });
    form.addEventListener('submit', function () {
      if (add && add.disabled) return;
      if (!reduce && add) {
        var r = add.getBoundingClientRect(), cart = cartTarget();
        if (cart) { var t = rect(cart); for (var k = 0; k < 6; k++) particle(r.left + r.width / 2 + (k - 3) * 8, r.top + r.height / 2, t.x, t.y, { size: 9, color: BEANS[k % 4], bend: (k - 3) * 18, lift: 120, rot: 320, dur: 760 + k * 40, delay: k * 30, s2: 0.3 }); }
      }
    });
    paint();
  }

  /* ---------- result, profile ---------- */
  var FLAVOR_KEY = { fruity: 'fruity', chocolatey: 'chocolate', nutty: 'nutty', floral: 'floral' };
  var FLAVOR_WORD = { fruity: 'bright, fruity', chocolatey: 'chocolatey', nutty: 'smooth, nutty', floral: 'floral' };
  function whyHTML(p) {
    if (!p) return '';
    var out = [];
    var rk = { light: 'light-roast', medium: 'medium-roast', dark: 'dark-roast' }[answers.roast];
    if (rk && p.match_roast === rk) {
      var rn = roastName(p), plain = cap(answers.roast) + ' roast';
      out.push('<b>' + esc(rn) + '</b>, ' + (rn.toLowerCase() === plain.toLowerCase() ? 'the shade you picked.' : 'close to the shade you picked.'));
    }
    var fk = FLAVOR_KEY[answers.flavor], notes = noteChips(p);
    if (fk && (p.match_flavor || []).indexOf(fk) > -1) out.push((notes.length ? '<b>' + esc(notes.slice(0, 2).join(' and ')) + '</b> in the cup' : 'The flavour') + ', for your ' + esc(FLAVOR_WORD[answers.flavor]) + ' palate.');
    var u = variantUI(p);
    if (heroV && heroV.o && u.grindIdx >= 0) {
      var g = String(heroV.o[u.grindIdx] || ''), want = GRIND_BY_BREW[answers.brew] || '';
      if (want && g.toLowerCase().indexOf(want) > -1) out.push(/whole/i.test(g) ? '<b>Whole bean</b>, so you grind it fresh for how you brew.' : '<b>' + esc(g) + '</b> grind, picked for how you brew.');
    }
    if (isOwn(p)) out.push('<b>Roasted to order</b> in Kuala Lumpur, with the roast date on the bag.');
    out = out.slice(0, 3);
    if (!out.length) return '';
    return '<div class="fmbx-whybox"><p class="fmbx-eyebrow">Why this one</p><ol class="fmbx-why">' + out.map(function (t, k) { return '<li style="--i:' + k + '"><i>0' + (k + 1) + '</i><span>' + t + '</span></li>'; }).join('') + '</ol></div>';
  }
  function whoHTML(prof, hid) {
    return '<div class="fmbx-who">' + badgeHTML(prof) +
      '<p class="fmbx-eyebrow">Your coffee personality</p>' +
      '<h1 class="fmbx-name result__name" id="' + hid + '" tabindex="-1" data-fmbx-head>' + words(prof.name) + '</h1>' +
      '<p class="fmbx-tag">' + esc(prof.tagline) + '</p>' +
      '<ul class="fmbx-traits">' + prof.traits.map(function (t, k) { return '<li style="--i:' + k + '">' + esc(t) + '</li>'; }).join('') + '</ul>' +
      '<p class="fmbx-blurb">' + esc(prof.blurb) + '</p></div>';
  }
  function runnerHTML() {
    if (!runnerP) return '';
    return '<a class="fmbx-runner" href="' + esc(runnerP.url) + '"><span class="fmbx-runner__img">' + (runnerP.image_sm || runnerP.image ? '<img src="' + esc(runnerP.image_sm || runnerP.image) + '" alt="" width="128" height="160" loading="lazy">' : '') + '</span>' +
      '<span><span class="fmbx-runner__k">Also worth a try</span><span class="fmbx-runner__n">' + esc(runnerP.name) + ' <em>· ' + esc(PROFILES[runnerId].name) + '</em></span></span>' +
      '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M5 10h10M11 6l4 4-4 4"/></svg></a>';
  }
  function sentHTML() {
    return '<div class="fmbx-note"><p class="fmbx-sent">You\u2019re on the list \u2713</p>' +
      (GATE_CODE ? '<p class="fmbx-sent">First order? Use <b>' + esc(GATE_CODE) + '</b> at checkout.</p>' : '') + '</div>';
  }
  function noteHTML() {
    return '<div class="fmbx-note"><p class="fmbx-note__t">' + esc(NOTE_TITLE) + '</p>' + signupFormHTML('Email me') +
      '<p class="fmbx-err" role="alert" data-fmbx-err>' + esc(restoreError) + '</p><p class="fmbx-fine">Fresh roasts and brewing tips. No spam. Unsubscribe any time.</p></div>';
  }
  function actsHTML(withShare) {
    return '<div class="fmbx-acts">' + (withShare ? '<button type="button" class="fmbx-link" data-act="share">Share my result</button>' : '') + '<button type="button" class="fmbx-link" data-act="retake">Retake the quiz</button></div>';
  }
  function bindCommon(el) {
    var sh = qs(el, '[data-act="share"]'); if (sh) sh.addEventListener('click', doShare);
    var rt = qs(el, '[data-act="retake"]'); if (rt) rt.addEventListener('click', doRetake);
  }
  function showResult(dir) {
    step = 'result';
    showTop(false);
    var prof = PROFILES[result];
    setTone(prof.tone);
    var hid = nid('fmbx-rh-');
    var el = makeScreen('fmbx-result', hid);
    var buy = heroP ? cardHTML(heroP) + runnerHTML() : '<div class="fmbx-note"><p class="fmbx-p2">We couldn’t load the coffee list just now.</p><a class="fmbx-btn" href="' + esc(BROWSE) + '"><span>Browse every coffee</span></a></div>';
    el.innerHTML = '<div class="fmbx-wrap fmbx-res" style="--pc:' + prof.pc + '">' +
      whoHTML(prof, hid) + '<div class="fmbx-buycol">' + buy + '</div>' +
      '<div class="fmbx-more">' + whyHTML(heroP) + actsHTML(true) +
      (MODE === 'gated' ? (noteSent ? sentHTML() : '') : (noteSent ? sentHTML() : noteHTML())) + '</div></div>';
    if (heroP) bindCard(qs(el, '[data-fmbx-card]'), heroP);
    bindCommon(el);
    var nf = qs(el, '.fmbx-note form[data-act="signup-form"]');
    if (nf) { var er = qs(el, '[data-fmbx-err]'); bindSignup(nf, 'note', function (m) { if (er) er.textContent = m || ''; }); }
    var celebrate = fresh;
    fresh = false;
    swap(el, dir, function () {
      focusHead(el);
      if (celebrate) { confetti(qs(el, '.fmbx-badge'), 30); later(function () { confetti(qs(el, '[data-fmbx-bag]'), 24); }, 380); }
    });
    say('You are ' + prof.name + '. Your match is ' + (heroP ? heroP.name : 'ready') + '.');
    scrollToStage();
    screenEvent();
  }
  function lockHTML(p) {
    var id = nid('fmbx-shine-');
    var notes = p ? noteChips(p) : [];
    var gt = esc(GATE_TITLE).replace(/&lt;(\/?)(em|b|strong|br)&gt;/g, '<$1$2>');
    return '<div class="fmbx-lock" style="--tone:' + esc((p && p.tone) || '#F29A7B') + '">' +
      '<div class="fmbx-lock__stage">' +
        '<svg class="fmbx-lock__bag" viewBox="0 0 120 150" aria-hidden="true" focusable="false"><defs><linearGradient id="' + id + '" x1="0" x2="1"><stop offset="0" stop-color="#fff" stop-opacity="0"/><stop offset=".5" stop-color="#fff" stop-opacity=".28"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient></defs>' +
        '<path class="sil" d="M22 18h76l8 120a6 6 0 0 1-6 6H20a6 6 0 0 1-6-6z"/><path d="M15.2 112c18-9 34 7 52-1s28-7 38.4-3.4l.4 30.4a6 6 0 0 1-6 6H20a6 6 0 0 1-6-6z" fill="#433634"/><path d="M22 18h76v10H22z" fill="#3A302E"/><path d="M52 58c0-6 4-10 8-10s8 4 8 10-4 12-8 16c-4-4-8-10-8-16z" fill="#3A302E"/><path class="shine" fill="url(#' + id + ')" d="M30 28h22l-6 112H24z"/></svg>' +
        '<span class="fmbx-lock__q" aria-hidden="true">?</span>' +
        (notes[0] ? '<span class="fmbx-chip fmbx-chip--a" aria-hidden="true"><i></i>' + esc(notes[0]) + '</span>' : '') +
        (notes[1] ? '<span class="fmbx-chip fmbx-chip--b" aria-hidden="true"><i></i>' + esc(notes[1]) + '</span>' : '') +
      '</div>' +
      (p ? '<p class="fmbx-card__meta">' + esc(roastName(p)) + ' · ' + esc(p.origin_label || '') + '</p>' : '') +
      '<p class="fmbx-lock__dots" aria-label="Coffee name hidden until you sign up">●●●●● ●●●●</p>' +
      (notes.length ? '<p class="fmbx-card__notes">Tastes of ' + esc(notes.join(', ')) + '</p>' : '') +
      '<div class="fmbx-gate" id="fmb-gate">' +
        '<h2 class="fmbx-gate__t">' + gt + '</h2>' +
        '<p class="fmbx-p2">' + esc(GATE_SUB) + '</p>' +
        (GATE_PERK ? '<p class="fmbx-gate__perk">' + esc(GATE_PERK) + '</p>' : '') +
        signupFormHTML(GATE_BTN) +
        '<p class="fmbx-err" role="alert" data-fmbx-err>' + esc(restoreError) + '</p>' +
        '<p class="fmbx-fine">Fresh roasts and brewing tips. No spam. Unsubscribe any time.</p>' +
        (ALLOW_SKIP ? '<button type="button" class="fmbx-link" data-act="skip-gate">Skip, just show the coffee</button>' : '') +
      '</div></div>';
  }
  function showProfile(dir) {
    step = 'profile';
    showTop(false);
    var prof = PROFILES[result];
    setTone(prof.tone);
    var hid = nid('fmbx-ph-');
    var el = makeScreen('fmbx-profile', hid);
    el.innerHTML = '<div class="fmbx-wrap fmbx-res" style="--pc:' + prof.pc + '">' + whoHTML(prof, hid) + '<div class="fmbx-buycol">' + lockHTML(heroP) + '</div><div class="fmbx-more">' + actsHTML(false) + '</div></div>';
    bindCommon(el);
    var gf = qs(el, '.fmbx-gate form[data-act="signup-form"]');
    if (gf) { var er = qs(el, '[data-fmbx-err]'); bindSignup(gf, 'gate', function (m) { if (er) er.textContent = m || ''; }); }
    var skip = qs(el, '[data-act="skip-gate"]');
    if (skip) skip.addEventListener('click', function () { track('QuizGateSkipped', { personality: result }); fresh = true; showResult(1); });
    var celebrate = fresh;
    fresh = false;
    swap(el, dir, function () {
      focusHead(el);
      if (celebrate) confetti(qs(el, '.fmbx-badge'), 26);
      var inp = gf && qs(gf, 'input[type="email"]');
      if (inp && !inp.value && fine) { try { inp.focus({ preventScroll: true }); } catch (e) {} }
    });
    say('You are ' + prof.name + '. Enter your email to see your coffee.');
    savePending('gate', restoredEmail, false);
    scrollToStage();
    screenEvent();
  }
  function doRetake() {
    clearTimers();
    answers = {}; result = null; heroP = null; heroV = null; runnerP = null; runnerId = null;
    noteSent = false; restoreError = ''; restoredEmail = ''; busy = false; fresh = false;
    ssDel(PENDING_KEY); ssDel(REVEALED_KEY);
    trail.forEach(function (li) { li.classList.remove('is-done', 'is-now'); });
    showIntro(-1);
  }
  function doShare() {
    var url = location.origin + location.pathname;
    var txt = 'I’m “' + (result ? PROFILES[result].name : 'a coffee lover') + '”. Find your Bean Shipper match.';
    if (navigator.share) { navigator.share({ title: 'Find my beans', text: txt, url: url }).catch(function () {}); }
    else if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(txt + ' ' + url).then(function () { toast('Link copied'); }, function () { toast(url); }); }
    else toast(url);
  }

  /* ---------- mount ---------- */
  var resume = restoreFromPending();
  if (resume) {
    intro.hidden = true;
    cur = null;
    if (resume === 'profile') showProfile(0); else showResult(0);
  } else {
    showTop(false);
  }
})();
